module.exports = __webpack_public_path__ + "static/media/ic-sort.c85cc022.svg";